"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSupportedFile = exports.supportedFileMimes = exports.supportedFileExts = exports.videoExts = exports.imageExts = void 0;
exports.imageExts = ['jpg', 'jpeg', 'gif', 'png', 'bmp', 'webp', 'svg'];
exports.videoExts = ['mp4', 'mov', 'avi', 'flv', 'mkv', 'wmv', 'avchd', 'webm', 'qt'];
var docExts = ['txt', 'doc', 'docx', 'xls', 'xlsx', 'csv', 'pdf'];
exports.supportedFileExts = __spreadArray(__spreadArray(__spreadArray([], exports.imageExts, true), exports.videoExts, true), docExts, true);
var docMimes = [
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-excel',
];
exports.supportedFileMimes = __spreadArray(['image/*', 'video/*', 'text/*'], docMimes, true);
/**
 * Determine if a file is supported or not with optional criteria
 * Used in favor of blacklisting all known files except the ones we want
 * @param file
 * @param options
 * @returns
 */
var isSupportedFile = function (file, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.supportedExtensions, supportedExtensions = _c === void 0 ? exports.supportedFileExts : _c;
    var name = file.name;
    var extension = name.split('.').pop() || undefined;
    return extension ? supportedExtensions.includes(extension) : false;
};
exports.isSupportedFile = isSupportedFile;
